import { render } from "./smallVat.vue?vue&type=template&id=71a8a42f&scoped=true"
import script from "./smallVat.vue?vue&type=script&lang=js"
export * from "./smallVat.vue?vue&type=script&lang=js"

import "./smallVat.vue?vue&type=style&index=0&id=71a8a42f&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71a8a42f"]])

export default __exports__